import { z } from 'zod';
/**
 * Carove kody zbozi (EAN-13, EAN-8, UPC-A). Ctecky vraci UPC-A jednou jako
 * 12 cislic, jindy jako EAN-13 s nulou na zacatku — uklada se proto vzdy tvar
 * s 13 cislicemi (EAN-8 zustava), aby se stejny vyrobek nasel pokazde.
 */
/** Vic balení téhož (maly a velky jogurt) — ale ne nekonecny seznam. */
export const MAX_BARCODES = 8;
function checkDigitOk(digits) {
    let sum = 0;
    // Vahy 3 a 1 stridave, od cislice pred kontrolni smerem doleva.
    for (let i = digits.length - 2, weight = 3; i >= 0; i -= 1, weight = 4 - weight) {
        sum += Number(digits[i]) * weight;
    }
    return (10 - (sum % 10)) % 10 === Number(digits[digits.length - 1]);
}
/** Kod v ulozenem tvaru, nebo null, kdyz to neni platny kod zbozi (preklep, QR, kod regalu). */
export function normalizeBarcode(raw) {
    let digits = raw.replace(/[\s-]/g, '');
    if (!/^\d+$/.test(digits))
        return null;
    if (digits.length === 14 && digits.startsWith('0'))
        digits = digits.slice(1);
    if (digits.length === 12)
        digits = `0${digits}`;
    if (digits.length !== 8 && digits.length !== 13)
        return null;
    return checkDigitOk(digits) ? digits : null;
}
export const BarcodeSchema = z.string().refine((value) => normalizeBarcode(value) === value, {
    message: 'Neplatný čárový kód',
});
export const BarcodesSchema = z
    .array(BarcodeSchema)
    .max(MAX_BARCODES)
    .transform((codes) => [...new Set(codes)]);
/** Prida kod na konec; kdyz uz je jich moc, vypadne nejstarsi. */
export function withBarcode(codes, code) {
    const rest = codes.filter((c) => c !== code);
    return [...rest, code].slice(-MAX_BARCODES);
}
//# sourceMappingURL=barcodes.js.map